export default __webpack_public_path__ + "src/images/packages/unembeza-boutique-lodge/4216e13400572488ffebaa2d1f9f0444-3.png";